import {FRESHDESK_STORE_NAME} from '../reducers/reducers'

export function getFreshdeskAuthenticationToken(state) {
    const stored = state[FRESHDESK_STORE_NAME] || { }
    return stored.token
}
